var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-contain"},[_c('div',{staticClass:"header-block"}),_c('div',{staticClass:"home-page"},[_c('div',{staticClass:"header"},[_c('img',{attrs:{"src":require("@/assets/Unoo-logo@3x.png"),"alt":""}}),_c('div',{staticClass:"header-btn-contain"})])])])
}]

export { render, staticRenderFns }